(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__sgLoaded) return;
  window.__sgLoaded = true;

  /* Default BODY measurements in CM */
  var WOMEN = { columns: ['Height', 'Bust', 'Waist Size', 'Hip Size'], rows: [
    ['XXS', '155-160', '78-82', '58-62', '83-87'],
    ['XS', '160-165', '82-86', '62-66', '87-91'],
    ['S', '165-170', '86-90', '66-70', '91-95'],
    ['M', '165-170', '90-94', '70-74', '95-99'],
    ['L', '170-175', '94-100', '74-80', '99-105'],
    ['XL', '170-175', '100-106', '80-86', '105-111'],
    ['XXL', '175-180', '106-112', '86-92', '111-117'],
    ['3XL', '175-180', '112-118', '92-98', '117-123'],
    ['4XL', '175-180', '118-124', '98-104', '123-129'],
    ['5XL', '175-180', '124-130', '104-110', '129-135'],
    ['6XL', '175-180', '130-136', '110-116', '135-141']
  ]};
  var WOMEN_B = { columns: ['Height', 'Waist Size', 'Hip Size'], rows: WOMEN.rows.map(function (r) { return [r[0], r[1], r[3], r[4]]; }) };
  var MEN = { columns: ['Height', 'Chest', 'Waist Size'], rows: [
    ['XS', '160-165', '82-86', '66-71'],
    ['S', '165-170', '86-91', '71-76'],
    ['M', '170-175', '91-97', '76-81'],
    ['L', '175-180', '97-104', '81-89'],
    ['XL', '180-185', '104-112', '89-97'],
    ['XXL', '180-185', '112-120', '97-104'],
    ['3XL', '185-190', '120-128', '104-112'],
    ['4XL', '185-190', '128-136', '112-120'],
    ['5XL', '190-195', '136-144', '120-128'],
    ['6XL', '190-195', '144-152', '128-136']
  ]};
  var MEN_B = { columns: ['Height', 'Waist Size', 'Hip Size'], rows: [
    ['XS', '160-165', '66-71', '84-89'], ['S', '165-170', '71-76', '89-94'], ['M', '170-175', '76-81', '94-99'],
    ['L', '175-180', '81-89', '99-106'], ['XL', '180-185', '89-97', '106-113'], ['XXL', '180-185', '97-104', '113-120'],
    ['3XL', '185-190', '104-112', '120-127'], ['4XL', '185-190', '112-120', '127-134'], ['5XL', '190-195', '120-128', '134-141']
  ]};
  var CURVE = { columns: ['Height', 'Bust', 'Waist Size', 'Hip Size'], rows: [
    ['0XL', '165-170', '102-107', '84-89', '107-112'],
    ['1XL', '165-170', '107-112', '89-94', '112-117'],
    ['2XL', '170-175', '112-117', '94-99', '117-122'],
    ['3XL', '170-175', '117-122', '99-104', '122-127'],
    ['4XL', '170-175', '122-127', '104-109', '127-132'],
    ['5XL', '170-175', '127-132', '109-114', '132-137']
  ]};
  var CURVE_B = { columns: ['Height', 'Waist Size', 'Hip Size'], rows: CURVE.rows.map(function (r) { return [r[0], r[1], r[3], r[4]]; }) };
  var BODY = { women: WOMEN, women_bottoms: WOMEN_B, men: MEN, men_bottoms: MEN_B };
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '0XL', '1XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  function isCurve(sizes) { return sizes.some(function (s) { return /^(0XL|1XL|0X|1X)$/.test(core(s)); }); }
  function curveName(s) { var v = core(s); return v.replace(/^(\d)X$/, '$1XL').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL'); }
  function rank(s, curve) { var v = curve ? curveName(s) : norm(s); var i = ORDER.indexOf(v); return i < 0 ? 99 : i; }
  var STANDARD = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var ALIAS = { 'XXXL': '3XL', 'XXXXL': '4XL', '2XL': 'XXL', '2X': 'XXL', '3X': '3XL', '4X': '4XL', '1X': 'XL', '1XL': 'XL', '0XL': 'L' };
  var FIT = { skinny: 0, slim: 25, regular: 50, loose: 75, oversized: 100 };

  /* International size conversion (base = US numeric; reference only) */
  var REGIONS = ['US', 'UK', 'EU', 'DE', 'IT', 'AU'];
  var W_US = { XXS: [0], XS: [2], S: [4], M: [6], L: [8, 10], XL: [12], XXL: [14], '3XL': [16], '4XL': [18], '5XL': [20], '6XL': [22] };
  var C_US = { '0XL': [12], '1XL': [14], '2XL': [16], '3XL': [18, 20], '4XL': [22], '5XL': [24, 26] };
  var W_OFF = { US: 0, UK: 4, EU: 32, DE: 30, IT: 36, AU: 4 };
  var M_CHEST = { XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44, '3XL': 46, '4XL': 48, '5XL': 50, '6XL': 52 };
  var M_WAIST = { XS: 28, S: 30, M: 32, L: 34, XL: 36, XXL: 38, '3XL': 40, '4XL': 42, '5XL': 44, '6XL': 46 };
  var COUNTRY = { US: 'US', CA: 'US', GB: 'UK', IE: 'UK', AU: 'AU', NZ: 'AU', DE: 'DE', AT: 'DE', CH: 'DE', IT: 'IT',
    FR: 'EU', ES: 'EU', PT: 'EU', BE: 'EU', NL: 'EU', LU: 'EU', GR: 'EU', PL: 'EU', SE: 'EU', DK: 'EU', FI: 'EU', NO: 'EU', CZ: 'EU', SK: 'EU', HU: 'EU', RO: 'EU', BG: 'EU', HR: 'EU', SI: 'EU', EE: 'EU', LV: 'EU', LT: 'EU', CY: 'EU', MT: 'EU' };
  function intl(s, region, cat, curve) {
    if (!region || region === 'std') return null;
    var men = /^men/.test(cat || ''), bottoms = /_bottoms$/.test(cat || '');
    if (men) {
      var k = norm(s), v = (bottoms ? M_WAIST : M_CHEST)[k];
      if (v === undefined) return null;
      if (region === 'EU' || region === 'DE' || region === 'IT') return String(v + (bottoms ? 16 : 10));
      return bottoms ? 'W' + v : String(v);
    }
    var base = curve ? C_US[curveName(s)] : null;
    if (!base) base = W_US[norm(s)];
    if (!base) return null;
    return base.map(function (n) { return n + W_OFF[region]; }).join('/');
  }
  function sizeCell(s, st) {
    var lab = intl(s, st.region, st.cfg.category, st.curve);
    return lab ? esc(lab) + '<small>' + esc(s) + '</small>' : esc(s);
  }

  /* ---------- Shoe sizes (EU manufacturer size; foot length = (EU + 10) / 2 cm) ---------- */
  /* [US, UK, Brazil, Australia] */
  var SHOE_W = { 33: ['3', '1', '31', '2'], 34: ['4', '2', '32', '3'], 35: ['5', '2.5', '33', '3.5'], 36: ['5.5', '3.5', '34', '4.5'], 37: ['6.5', '4', '35', '5'], 38: ['7.5', '5', '36', '6'], 39: ['8.5', '6', '37', '7'], 40: ['9', '6.5', '38', '7.5'], 41: ['9.5', '7', '39', '8'], 42: ['10', '7.5', '40', '8.5'], 43: ['10.5', '8', '41', '9'], 44: ['11', '8.5', '42', '9.5'], 45: ['11.5', '9', '43', '10'], 46: ['12', '9.5', '44', '10.5'], 47: ['12.5', '10', '45', '11'], 48: ['13', '10.5', '46', '11.5'] };
  var SHOE_M = { 33: ['2', '1.5', '31', '1.5'], 34: ['3', '2.5', '32', '2.5'], 35: ['3.5', '3', '33', '3'], 36: ['4', '3.5', '34', '3.5'], 37: ['5', '4.5', '35', '4.5'], 38: ['5.5', '5', '36', '5'], 39: ['6.5', '6', '37', '6'], 40: ['7', '6.5', '38', '6.5'], 41: ['8', '7', '39', '7'], 42: ['8.5', '8', '40', '8'], 43: ['9.5', '9', '41', '9'], 44: ['10', '9.5', '42', '9.5'], 45: ['11', '10.5', '43', '10.5'], 46: ['12', '11', '44', '11'], 47: ['12.5', '12', '45', '12'], 48: ['13.5', '13', '46', '13'], 49: ['14', '13.5', '47', '13.5'], 50: ['15', '14.5', '48', '14.5'] };
  var SHOE_K = { 20: ['4.5K', '4K', '18', '4K'], 21: ['5.5K', '5K', '19', '5K'], 22: ['6.5K', '6K', '20', '6K'], 23: ['7K', '6.5K', '21', '6.5K'], 24: ['8K', '7K', '22', '7K'], 25: ['8.5K', '8K', '23', '8K'], 26: ['9.5K', '9K', '24', '9K'], 27: ['10K', '9.5K', '25', '9.5K'], 28: ['11K', '10.5K', '26', '10.5K'], 29: ['12K', '11K', '27', '11K'], 30: ['12.5K', '12K', '28', '12K'], 31: ['13.5K', '13K', '29', '13K'], 32: ['1Y', '13.5K', '30', '13.5K'] };
  var SHOE_COLS = ['US', 'UK', 'BR', 'AU'];
  var SHOE_HEAD = { US: 'US Size', UK: 'Great Britain', BR: 'Brazil', AU: 'Australia' };
  var SHOE_COUNTRY = { US: 'US', CA: 'US', GB: 'UK', IE: 'UK', AU: 'AU', NZ: 'AU', BR: 'BR' };
  function footCm(eu) { return (parseFloat(eu) + 10) / 2; }
  /* Size labels like "37", "EUR37", "CN37", "US8.5", "UK5" */
  function shoeParse(s) {
    var t = String(s).toUpperCase().replace(/\s+/g, '');
    var r = t.match(/^(EUR|EU|CN)?(\d+)-(\d+)$/);
    if (r) return { sys: 'EU', n: parseFloat(r[3]), range: true };
    var m = t.match(/^(EUR|EU|CN|US|UK)?([\d.]+)$/);
    if (!m) return null;
    var n = parseFloat(m[2]);
    /* a bare 5..12 on a shoe is a US size */
    return { sys: m[1] || (n <= 16 ? 'US' : 'EU'), n: n };
  }
  function invertShoe(val, col, gender) {
    var tbl = gender === 'men' ? SHOE_M : SHOE_W, pts = [];
    Object.keys(tbl).forEach(function (k) { pts.push([parseFloat(k), parseFloat(tbl[k][col])]); });
    pts.sort(function (a, b) { return a[0] - b[0]; });
    for (var i = 0; i < pts.length; i++) if (pts[i][1] === val) return pts[i][0];
    for (var j = 0; j < pts.length - 1; j++) {
      var a = pts[j], b = pts[j + 1];
      if (val > a[1] && val < b[1]) return Math.round((a[0] + (val - a[1]) / (b[1] - a[1]) * (b[0] - a[0])) * 2) / 2;
    }
    return NaN;
  }
  function euOf(s, gender) {
    var p = shoeParse(s);
    if (!p) return NaN;
    if (p.sys === 'US') return invertShoe(p.n, 0, gender);
    if (p.sys === 'UK') return invertShoe(p.n, 1, gender);
    return p.n;
  }
  function shoeRowExact(n, gender) {
    if (n < 33) return SHOE_K[n] || null;
    return (gender === 'men' ? SHOE_M : SHOE_W)[n] || null;
  }
  function shoeRow(eu, gender) {
    var n = parseFloat(eu), row = shoeRowExact(n, gender);
    if (row || n % 1 === 0) return row;
    /* half sizes (e.g. 39.5): halfway between the two whole sizes */
    var lo = shoeRowExact(Math.floor(n), gender), hi = shoeRowExact(Math.ceil(n), gender);
    if (!lo || !hi) return null;
    return lo.map(function (v, i) {
      var a = parseFloat(v), b = parseFloat(hi[i]);
      if (isNaN(a) || isNaN(b) || /[A-Z]/i.test(v + hi[i])) return '-';
      var m = Math.round((a + b) / 2 * 2) / 2;
      return String(m);
    });
  }
  function fmt2(n) { var r = Math.round(n * 100) / 100; return String(r); }
  var SHOE_FIG =
    '<figure><svg viewBox="0 0 200 130"><path d="M60 20 Q58 60 62 78 Q40 84 26 92 Q14 100 22 106 L150 106 Q172 106 170 92 Q166 80 120 74 Q100 70 96 50 L96 20 Z" fill="#fff" stroke="#888" stroke-width="2"/>' +
      '<path d="M18 112 V100 M172 112 V100" stroke="#333" stroke-dasharray="3 3"/><path d="M20 118 H170" stroke="#222" stroke-width="2" marker-start="url(#sga)" marker-end="url(#sgb)"/>' +
      '<defs><marker id="sga" markerWidth="8" markerHeight="8" refX="1" refY="4" orient="auto"><path d="M8 0 L0 4 L8 8" fill="none" stroke="#222"/></marker><marker id="sgb" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto"><path d="M0 0 L8 4 L0 8" fill="none" stroke="#222"/></marker></defs></svg>' + '%B1%</figure>' +
    '<figure><svg viewBox="0 0 200 130"><path d="M14 92 Q12 70 40 70 L90 66 Q104 40 128 36 L150 36 Q176 40 182 70 Q188 96 170 102 L30 104 Q14 104 14 92 Z" fill="#9a9a9a"/>' +
      '<path d="M24 92 Q22 78 44 78 L92 74 Q108 50 128 46 L148 46 Q170 50 174 72 Q178 92 164 95 L34 96 Q24 96 24 92 Z" fill="#f0a623"/>' +
      '<path d="M30 90 Q30 82 48 82 L96 80 Q110 58 130 54 L146 54 Q164 58 166 74 Q168 88 158 89 L40 90 Z" fill="#fff" stroke="#888" stroke-width="1.5"/>' +
      '<path d="M24 118 H174" stroke="#222" stroke-width="2" marker-start="url(#sga)" marker-end="url(#sgb)"/><path d="M24 112 V96 M174 112 V96" stroke="#333" stroke-dasharray="3 3"/></svg>' + '%B2%</figure>' +
    '<figure><svg viewBox="0 0 200 130"><path d="M78 118 Q66 92 68 64 Q66 38 76 26 Q84 16 92 22 Q98 12 106 20 Q114 12 120 22 Q128 18 132 30 Q140 30 138 46 Q140 70 132 96 Q126 120 104 122 Q86 124 78 118 Z" fill="#fff" stroke="#888" stroke-width="2"/>' +
      '<circle cx="68" cy="56" r="9" fill="none" stroke="#f0a623" stroke-width="2" stroke-dasharray="3 3"/><circle cx="140" cy="54" r="9" fill="none" stroke="#f0a623" stroke-width="2" stroke-dasharray="3 3"/>' +
      '<path d="M70 56 H138" stroke="#222" stroke-width="2" marker-start="url(#sga)" marker-end="url(#sgb)"/></svg>' + '%B3%</figure>';
  var SHOE_STEPS = [
    ['Foot Length', 'Stand on a sheet of paper, mark the heel and the tip of the longest toe, then measure the distance. Measure both feet and use the longer one.'],
    ['Shoe Inner Length', 'The length from the heel to the toe inside the shoe. It is usually 0.5–1 cm longer than the foot.'],
    ['Foot Width', 'Measure the widest part of your foot from side to side. If your feet are wide, consider one size up.']
  ];
  var DESC = {
    shoulder: 'Measure from where the shoulder seam meets the sleeve on one side to the other side.',
    bust: 'Measure straight across from the stitches below one armpit to the other.',
    chest: 'Measure straight across from the stitches below one armpit to the other.',
    waist: 'Measure straight across the narrowest part of the waist, from edge to edge.',
    hips: 'Measure straight across the widest part of the hips, from edge to edge.',
    length: 'Measure from where the shoulder seam meets the collar down to the hem.',
    'sleeve length': 'Measure from the shoulder seam down to the end of the cuff.',
    inseam: 'Measure from the crotch seam down to the bottom of the leg.',
    thigh: 'Measure straight across the leg just below the crotch.',
    'pants length': 'Measure from the top of the waistband down to the hem.'
  };
  var BODY_DESC = {
    bust: 'Measure the circumference over the fullest part of your bust.',
    chest: 'Measure the circumference over the fullest part of your chest, under the armpits.',
    waist: 'Measure your waist at the thinnest place.',
    hips: 'Measure the fullest part of your hips.'
  };

  var O = 'fill="none" stroke="#f08a24" stroke-width="2"';
  function badge(x, y, n) { return '<circle cx="' + x + '" cy="' + y + '" r="9" fill="#222"/><text x="' + x + '" y="' + (y + 4) + '" text-anchor="middle" font-size="11" font-weight="700" fill="#fff" font-family="Arial">' + n + '</text>'; }
  var FIG = {
    garment: { map: { shoulder: 1, bust: 2, chest: 2, waist: 3, hips: 4, length: 5, 'sleeve length': 6 }, svg:
      '<svg viewBox="0 0 220 250"><path d="M92 20 Q110 34 128 20 L152 26 L182 122 L167 127 L146 72 L144 110 L162 228 L58 228 L76 110 L74 72 L53 127 L38 122 L68 26 Z" fill="#fff" stroke="#333" stroke-width="1.4"/>' +
      '<path d="M70 27 H150" ' + O + '/><path d="M75 72 H145" ' + O + '/><path d="M77 106 H143" ' + O + '/><path d="M73 138 H147" ' + O + '/>' +
      '<path d="M24 20 V228" ' + O + '/><path d="M24 20 H92 M24 228 H58" stroke="#bbb" stroke-dasharray="2 3"/><path d="M158 22 L190 120" ' + O + '/>' +
      badge(62, 17, 1) + badge(110, 86, 2) + badge(155, 106, 3) + badge(155, 145, 4) + badge(12, 124, 5) + badge(198, 66, 6) + '</svg>' },
    pants: { map: { waist: 1, hips: 2, inseam: 3, length: 4, 'pants length': 4, thigh: 5 }, svg:
      '<svg viewBox="0 0 220 250"><path d="M66 20 H154 L164 228 H118 L110 96 L102 228 H56 Z" fill="#fff" stroke="#333" stroke-width="1.4"/><path d="M66 34 H154" stroke="#333"/>' +
      '<path d="M66 27 H154" ' + O + '/><path d="M61 62 H159" ' + O + '/><path d="M60 104 H106" ' + O + '/><path d="M113 104 L119 226" ' + O + '/><path d="M36 20 V228" ' + O + '/>' +
      badge(110, 14, 1) + badge(172, 62, 2) + badge(132, 170, 3) + badge(24, 124, 4) + badge(83, 118, 5) + '</svg>' },
    body: { map: { bust: 1, chest: 1, waist: 2, hips: 3 }, svg:
      '<svg viewBox="0 0 220 250"><circle cx="110" cy="26" r="15" fill="#f4f4f4" stroke="#333" stroke-width="1.4"/>' +
      '<path d="M101 41 H119 L122 52 L150 60 L158 132 L149 134 L141 84 L136 110 L146 150 L133 234 H117 L111 162 H109 L103 234 H87 L74 150 L84 110 L79 84 L71 134 L62 132 L70 60 L98 52 Z" fill="#eee" stroke="#333" stroke-width="1.4"/>' +
      '<ellipse cx="110" cy="82" rx="34" ry="5" ' + O + '/><ellipse cx="110" cy="110" rx="28" ry="5" ' + O + '/><ellipse cx="110" cy="142" rx="39" ry="6" ' + O + '/>' +
      badge(162, 82, 1) + badge(58, 110, 2) + badge(164, 146, 3) + '</svg>' }
  };

  function key(name) {
    var k = String(name).toLowerCase().replace(/\bsize\b/g, '').trim();
    if (k === 'hip') k = 'hips';
    if (k === 'sleeve') k = 'sleeve length';
    return k;
  }
  function raw(s) { return String(s).toUpperCase().replace(/\(.*?\)/g, '').replace(/\s+/g, '').trim(); }
  function core(s) {
    var v = raw(s);
    if (ORDER.indexOf(ALIAS[v] || v) > -1 || /^\dXL?$/.test(v)) return v;
    var t = String(s).toUpperCase().replace(/\(.*?\)/g, ' ').split(/\s+/);
    for (var i = 0; i < t.length; i++) { if (t[i] && (ORDER.indexOf(ALIAS[t[i]] || t[i]) > -1 || /^\dXL?$/.test(t[i]))) return t[i]; }
    return v;
  }
  function norm(s) { var v = core(s); return ALIAS[v] || v; }
  function fmt(n) { var r = Math.round(n * 10) / 10; return (r % 1 === 0) ? String(r) : r.toFixed(1); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function conv(val, from, to) {
    if (val === null || val === undefined || val === '') return '-';
    if (from === to) return esc(val);
    var f = from === 'cm' ? 1 / 2.54 : 2.54;
    return esc(String(val).replace(/\d+(\.\d+)?/g, function (m) { return fmt(parseFloat(m) * f); }));
  }
  function toRows(chart) {
    if (Array.isArray(chart.rows)) return chart.rows;
    return Object.keys(chart.rows || {}).map(function (s) { return [s].concat(chart.rows[s]); });
  }
  /* Keep only the product's sizes, in the product's order, labelled as the product labels them */
  function pick(rows, sizes, fallbackStandard, curve) {
    var out = [];
    sizes.slice().sort(function (a, b) { return rank(a, curve) - rank(b, curve); }).forEach(function (s) {
      var n = curve ? curveName(s) : norm(s), r = null;
      for (var i = 0; i < rows.length; i++) { if (raw(rows[i][0]) === raw(s)) { r = rows[i]; break; } }
      if (!r) for (var j = 0; j < rows.length; j++) { if ((curve ? curveName(rows[j][0]) : norm(rows[j][0])) === n) { r = rows[j]; break; } }
      if (r) out.push([s].concat(r.slice(1)));
    });
    if (out.length) return out;
    return fallbackStandard ? rows.filter(function (r) { return STANDARD.indexOf(r[0]) > -1; }) : rows;
  }
  function getRegion(country) { try { var r = localStorage.getItem('sg-region'); if (r) return r; } catch (e) {} return COUNTRY[String(country || '').toUpperCase()] || 'std'; }
  function setRegion(r) { try { localStorage.setItem('sg-region', r); } catch (e) {} }
  function getUnit() { try { return localStorage.getItem('sg-unit') || 'in'; } catch (e) { return 'in'; } }
  function setUnit(u) { try { localStorage.setItem('sg-unit', u); } catch (e) {} }

  function buildShoe(root, cfg) {
    var g = cfg.gender === 'men' ? 'men' : 'women';
    var sizes = (cfg.sizes || []).filter(function (s) { return s && !isNaN(euOf(s, g)); }).slice().sort(function (a, b) { return euOf(a, g) - euOf(b, g) || String(a).localeCompare(String(b)); });
    var reg; try { reg = localStorage.getItem('sg-shoe-region'); } catch (e) {}
    var unit; try { unit = localStorage.getItem('sg-shoe-unit'); } catch (e) {}
    var st = { shoe: true, cfg: cfg, sizes: sizes, gender: g, region: reg || SHOE_COUNTRY[String(cfg.country || '').toUpperCase()] || 'std', unit: unit || 'cm', rec: null, foot: null };
    var allKids = sizes.length > 0 && sizes.every(function (s) { return euOf(s, g) < 33; });
    root.querySelector('.sg-gender').hidden = allKids;
    root.querySelector('.sg-shoe-figs').innerHTML = SHOE_FIG.replace('%B1%', badge2(1)).replace('%B2%', badge2(2)).replace('%B3%', badge2(3));
    root.querySelector('.sg-shoe-steps').innerHTML = SHOE_STEPS.map(function (s, i) { return '<li><strong><span class="sg-num">' + (i + 1) + '</span>' + s[0] + '</strong><p>' + s[1] + '</p></li>'; }).join('');
    root.__sg = st;
    return st;
  }
  function badge2(n) { return '<svg viewBox="0 0 30 30" width="30" height="30" style="max-width:30px"><circle cx="15" cy="15" r="13" fill="#111"/><text x="15" y="20" text-anchor="middle" font-size="15" font-weight="700" fill="#fff" font-family="Arial">' + n + '</text></svg>'; }
  function renderShoe(root) {
    var st = root.__sg;
    var sel = selectedSize(root, st.sizes);
    root.querySelector('.sg-region').value = st.region;
    root.querySelectorAll('.sg-unit').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unit === st.unit); });
    root.querySelectorAll('.sg-gbtn').forEach(function (b) { b.classList.toggle('is-active', b.dataset.gender === st.gender); });
    root.querySelector('.sg-foot-unit').textContent = st.unit;
    var cols = SHOE_COLS.slice();
    if (st.region !== 'std') cols = [st.region].concat(cols.filter(function (c) { return c !== st.region; }));
    var h = '<thead><tr><th>Size</th><th>Heel to Toe (' + st.unit + ')</th>' + cols.map(function (c) { return '<th' + (c === st.region ? ' class="is-region"' : '') + '>' + SHOE_HEAD[c] + '</th>'; }).join('') + '</tr></thead><tbody>';
    st.sizes.forEach(function (s) {
      var eu = euOf(s, st.gender), p = shoeParse(s);
      var row = isNaN(eu) ? null : shoeRow(eu, st.gender), cm = footCm(eu);
      var len = st.unit === 'cm' ? fmt2(cm) : fmt2(cm / 2.54);
      var cls = [];
      if (sel && raw(s) === sel) cls.push('is-selected');
      if (st.rec === s) cls.push('is-rec');
      var lab = esc(s) + ((p && (p.sys === 'US' || p.sys === 'UK') && !isNaN(eu)) ? '<small>EU ' + esc(String(eu)) + '</small>' : '');
      h += '<tr' + (cls.length ? ' class="' + cls.join(' ') + '"' : '') + '><td>' + lab + '</td><td>' + (isNaN(cm) ? '-' : len) + '</td>';
      cols.forEach(function (c) { var v = row ? row[SHOE_COLS.indexOf(c)] : '-'; h += '<td' + (c === st.region ? ' class="is-region"' : '') + '>' + esc(v) + '</td>'; });
      h += '</tr>';
    });
    root.querySelector('.sg-table').innerHTML = h + '</tbody>';
  }
  function findShoe(root) {
    var st = root.__sg, input = root.querySelector('.sg-foot'), out = root.querySelector('.sg-find-result');
    var v = parseFloat(String(input.value).replace(',', '.'));
    if (!v || v <= 0) { out.textContent = 'Please enter your foot length.'; st.rec = null; renderShoe(root); return; }
    var cm = st.unit === 'in' ? v * 2.54 : v;
    if (cm < 10 || cm > 40) { out.textContent = 'Please check the number and the unit (cm / in).'; st.rec = null; renderShoe(root); return; }
    var pick = null;
    for (var i = 0; i < st.sizes.length; i++) { if (footCm(euOf(st.sizes[i], st.gender)) >= cm - 0.001) { pick = st.sizes[i]; break; } }
    if (!pick) { st.rec = null; out.textContent = 'Your foot is longer than the largest size available for this item.'; renderShoe(root); return; }
    st.rec = pick;
    var row = shoeRow(euOf(pick, st.gender), st.gender);
    var extra = (st.region !== 'std' && row) ? ' (' + SHOE_HEAD[st.region] + ' ' + row[SHOE_COLS.indexOf(st.region)] + ')' : '';
    out.innerHTML = 'Recommended size: <b>' + esc(pick) + extra + '</b>';
    renderShoe(root);
  }

  function build(root) {
    var cfg; try { cfg = JSON.parse(root.querySelector('.sg-config').textContent); } catch (e) { cfg = {}; }
    var custom = cfg.custom || {};
    var srcUnit = String(custom.unit || 'cm').toLowerCase();
    var sizes = (cfg.sizes || []).filter(Boolean);
    var charts = {};
    var curve = isCurve(sizes);
    if (custom.product && custom.product.columns) {
      charts.product = { columns: custom.product.columns, rows: pick(toRows(custom.product), sizes, false, curve), unit: srcUnit };
    }
    if (custom.body && custom.body.columns) {
      charts.body = { columns: custom.body.columns, rows: pick(toRows(custom.body), sizes, false, curve), unit: srcUnit };
    } else {
      var cat = cfg.category || 'women';
      var def = BODY[cat] || WOMEN;
      if (curve && cat.indexOf('women') === 0) {
        /* Curve sizes (0XL-5XL) + any regular sizes (XXS-XL) mixed in the same product */
        var reg = def.rows.filter(function (r) { return ['XXS', 'XS', 'S', 'M', 'L', 'XL'].indexOf(r[0]) > -1; });
        var cv = cat === 'women_bottoms' ? CURVE_B : CURVE;
        def = { columns: def.columns, rows: reg.concat(cv.rows) };
      }
      charts.body = { columns: def.columns, rows: pick(def.rows, sizes, true, curve && cat.indexOf('women') === 0), unit: 'cm' };
    }
    var st = { cfg: cfg, sizes: sizes, charts: charts, curve: curve, unit: getUnit(), region: getRegion(cfg.country), tab: charts.product ? 'product' : 'body' };
    root.querySelector('.sg-tab[data-tab="product"]').hidden = !charts.product;
    var fitKey = String(custom.fit || '').toLowerCase();
    var fitBox = root.querySelector('.sg-fit');
    if (FIT[fitKey] !== undefined) {
      fitBox.hidden = false;
      fitBox.querySelector('.sg-fit-marker').style.left = FIT[fitKey] + '%';
    } else fitBox.hidden = true;
    root.__sg = st;
    return st;
  }

  function selectedSize(root, sizes) {
    var scope = root.closest('.shopify-section') || root.closest('section') || document;
    var els = scope.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select, input[type="radio"]:checked');
    var wanted = sizes.map(raw);
    for (var i = 0; i < els.length; i++) {
      var v = raw(els[i].value);
      if (wanted.indexOf(v) > -1) return v;
    }
    return null;
  }

  function render(root) {
    var st = root.__sg || build(root);
    var sel = selectedSize(root, st.sizes);
    var isConv = st.tab === 'convert';
    root.querySelector('.sg-region').value = st.region;
    root.querySelector('.sg-units').hidden = isConv;
    root.querySelector('.sg-howto').hidden = isConv;
    root.querySelector('.sg-note-conv').hidden = !isConv;
    root.querySelector('.sg-note-std').hidden = isConv;
    root.querySelectorAll('.sg-tab').forEach(function (b) { var on = b.dataset.tab === st.tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    if (isConv) {
      var list = st.charts.body.rows.map(function (r) { return r[0]; });
      var h = '<thead><tr><th>Standard</th>' + REGIONS.map(function (g) { return '<th' + (g === st.region ? ' class="is-region"' : '') + '>' + g + '</th>'; }).join('') + '</tr></thead><tbody>';
      list.forEach(function (s) {
        h += '<tr' + (sel && raw(s) === sel ? ' class="is-selected"' : '') + '><td>' + esc(s) + '</td>';
        REGIONS.forEach(function (g) { h += '<td' + (g === st.region ? ' class="is-region"' : '') + '>' + esc(intl(s, g, st.cfg.category, st.curve) || '-') + '</td>'; });
        h += '</tr>';
      });
      root.querySelector('.sg-table').innerHTML = h + '</tbody>';
      return;
    }
    var c = st.charts[st.tab];
    var html = '<thead><tr><th>' + (st.region !== 'std' ? esc(st.region) + ' Size' : 'Size') + '</th>' + c.columns.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>';
    c.rows.forEach(function (r) {
      html += '<tr' + (sel && raw(r[0]) === sel ? ' class="is-selected"' : '') + '><td>' + sizeCell(r[0], st) + '</td>';
      for (var i = 1; i <= c.columns.length; i++) html += '<td>' + conv(r[i], c.unit, st.unit) + '</td>';
      html += '</tr>';
    });
    root.querySelector('.sg-table').innerHTML = html + '</tbody>';

    root.querySelectorAll('.sg-unit').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unit === st.unit); });

    var isBody = st.tab === 'body';
    var bottoms = /_bottoms$/.test(st.cfg.category || '');
    var fig = isBody ? FIG.body : (bottoms ? FIG.pants : FIG.garment);
    var dict = isBody ? BODY_DESC : DESC;
    root.querySelector('.sg-howto-title').textContent = isBody ? 'How to Measure your Body?' : "How to Measure the Product's Size?";
    var items = [];
    c.columns.forEach(function (col) {
      var k = key(col);
      if (!dict[k]) return;
      items.push({ n: fig.map[k], label: String(col).replace(/\s*size$/i, ''), d: dict[k] });
    });
    items.sort(function (a, b) { return (a.n || 99) - (b.n || 99); });
    root.querySelector('.sg-steps').innerHTML = items.map(function (it) {
      return '<li><strong>' + (it.n ? '<span class="sg-num">' + it.n + '</span>' : '') + (isBody ? 'Your ' : '') + esc(it.label) + '</strong><p>' + it.d + '</p></li>';
    }).join('');
    root.querySelector('.sg-figure').innerHTML = fig.svg;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var trig = t.closest('.sg-trigger');
    if (trig) {
      var root = trig.closest('.sg-root');
      if (root.classList.contains('sg-root--shoe')) {
        var cfgS; try { cfgS = JSON.parse(root.querySelector('.sg-config').textContent); } catch (e2) { cfgS = {}; }
        buildShoe(root, cfgS); renderShoe(root);
        var dlgS = root.querySelector('.sg-dialog');
        if (dlgS.showModal) dlgS.showModal(); else dlgS.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        return;
      }
      var st0 = build(root);
      if (trig.dataset.openTab) st0.tab = trig.dataset.openTab;
      render(root);
      var dlg = root.querySelector('.sg-dialog');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    var r = t.closest('.sg-root');
    if (!r) return;
    var dlg2 = r.querySelector('.sg-dialog');
    if (t.closest('.sg-close') || t === dlg2) { dlg2.close ? dlg2.close() : dlg2.removeAttribute('open'); return; }
    if (r.__sg && r.__sg.shoe) {
      var ub = t.closest('.sg-unit'), gb = t.closest('.sg-gbtn');
      if (ub) {
        var nu = ub.dataset.unit, inp = r.querySelector('.sg-foot');
        if (nu !== r.__sg.unit && inp.value) { var x = parseFloat(inp.value); if (x) inp.value = fmt2(nu === 'in' ? x / 2.54 : x * 2.54); }
        r.__sg.unit = nu; try { localStorage.setItem('sg-shoe-unit', nu); } catch (e3) {} renderShoe(r); return;
      }
      if (gb) { var gg = gb.dataset.gender; r.__sg.gender = gg; r.__sg.sizes.sort(function (a, b) { return euOf(a, gg) - euOf(b, gg) || String(a).localeCompare(String(b)); }); if (r.__sg.rec) findShoe(r); else renderShoe(r); return; }
      if (t.closest('.sg-find')) { findShoe(r); return; }
      return;
    }
    var tab = t.closest('.sg-tab');
    if (tab && r.__sg) { r.__sg.tab = tab.dataset.tab; render(r); return; }
    var unit = t.closest('.sg-unit');
    if (unit && r.__sg) { r.__sg.unit = unit.dataset.unit; setUnit(unit.dataset.unit); render(r); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.classList.contains('sg-region')) return;
    var r = t.closest('.sg-root');
    if (r && r.__sg && r.__sg.shoe) { r.__sg.region = t.value; try { localStorage.setItem('sg-shoe-region', t.value); } catch (e4) {} if (r.__sg.rec) findShoe(r); else renderShoe(r); return; }
    if (r && r.__sg) { r.__sg.region = t.value; setRegion(t.value); render(r); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target instanceof Element && e.target.classList.contains('sg-foot')) {
      e.preventDefault();
      var r = e.target.closest('.sg-root');
      if (r && r.__sg && r.__sg.shoe) findShoe(r);
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target instanceof Element && e.target.classList.contains('sg-dialog')) document.documentElement.style.overflow = '';
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
